import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Store } from "@modules/stores/types";
import { StoreFormValues } from "@modules/stores/validations";

import { createStoreService } from "./service";
import { UseCreateStoreMutationOptions } from "./types";
import { useNavigate } from "react-router";

export function useCreateStoreMutation(
  options?: UseCreateStoreMutationOptions
) {
  const translate = useTranslate();
  const navigate = useNavigate();
  const { open } = useNotification();

  return useMutation<Store, ApiError, StoreFormValues>({
    mutationFn: createStoreService,
    onSuccess: (store: Store) => {
      open?.({
        type: "success",
        message: translate("v1/store_admin.success.create"),
      });

      navigate(`/stores/edit/${store.id}`);
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
